import { Subject } from 'rxjs/Subject';
var DraggableHelper = (function () {
    function DraggableHelper() {
        this.currentDrag = new Subject();
    }
    return DraggableHelper;
}());
export { DraggableHelper };
//# sourceMappingURL=draggableHelper.provider.js.map


//////////////////
// WEBPACK FOOTER
// /Users/ggueret/Desktop/Personnel/Angular/ares-app/~/angular-draggable-droppable/dist/esm/src/draggableHelper.provider.js
// module id = ../../../../angular-draggable-droppable/dist/esm/src/draggableHelper.provider.js
// module chunks = 3